module.exports = __webpack_public_path__ + "img/timer.a21bb80e.gif";